const home = {
  headTitle: "成为全球知名品牌最信赖的电商伙伴",
  headContent: "多麦成立于2010年8月，迄今为止合作全球优质互联网新媒体资源几十万家，自有加合作的自媒体 (新媒体) 涵盖的粉丝数达数千万，通过自主研发的精准营销技术、大数据技术， 实现基于广告预算、地域和目标用户画像的新媒体程序化广告投放......",
  headBtn: "了解更多",
  comBusiness: "公司业务",

  MaiJiaAd: "广告营销",

  MaiJiaUniverse: "麦加全域",
  MaiJiaUniverseTitle: "为品牌提供品效合一服务",
  MaiJiaUniverseContent1: "麦加广告是中国效果营销的优质服务机构，提供专业的效果营销服务，拥有全国领先的广告监测系统以及全域营销数据系统。",
  MaiJiaUniverseContent2: "真实，客观的数据是我们对客户的保证。",
  MaiJiaUniverseContent3: "合适的方案才是好的方案 - 经验丰富的营销团队为品牌定制专属营销方案，深度挖掘品牌需求，精确定位用户群体，保证声量的同时提升转化，品效合一是我们的强项，成立至今我们已完成了近百家品牌营销服务。我们是麦加，是你值得信赖的伙伴，选择麦加，就是选择品效合一！",

  MaiMeng: "麦盟CPS",
  MaiMengTitle: "专注全球新零售效果营销服务",
  MaiMengContent1: "多麦CPS广告联盟—专注全球新零售效果营销服务。",
  MaiMengContent2: "专注效果营销广告服务十余年，精湛的广告技术，专业的服务团队，为全球新零售平台以及广大媒体渠道提供优质效果营销方案，实现流量精准化，销量高转化，收益高效化。",

  organization: "MCN机构",

  shaomai: "烧麦",
  shaomaiTitle: "致力于成为内容第一的全平台MCN机构",
  shaomaiContent1: "烧麦文化是多麦旗下MCN部门，2018年组建，自有KOL矩阵立足于泛时尚领域。",
  shaomaiContent2: "重点布局小红书、b站、微博等社交平台，已签约腰部以上红人20+，全平台粉丝覆盖800W+。哔哩哔哩、抖音、小红书等新兴年轻人聚集社交平台粉丝覆盖100W+，小红书独家约kol 27人，服务雅诗兰黛、纪梵希、兰蔻、Nike、IT商城、FILA等泛时尚品牌，月广告收入达50w左右。",
  shaomaiContent3: "致力于打造多平台联合发展、稳定产出优质内容的高质量型红人，成为以内容为第一生产力的全平台mcn机构。",

  liveStreaming: "直播机构",
  
  mailang: "麦浪直播",
  mailangTitle: "LIVE × Video，一站式电商融媒体聚合服务专家",
  mailangContent1: "中国领先的网红内容电商解决方案服务商，业务涵盖品牌代播、 PUGC & POGC直播运营、网红内容电商、电商视频制作、主播经纪、主播培训、节目制作、广告招商等。",
  mailangContent2: "麦浪直播机构通过聚合高品质电商主播、孵化素人主播、操盘艺人入圈电商直播生态，为品牌客户提供淘宝、抖音、京东、腾讯等所需直播平台的一站式直播代运营服务。通过为品牌高效匹配适宜的红人主播，完成产品销售和广告销售进行流量变现。",

  youmai: "优麦",
  youmaiTitle: "专注新媒体运营、社会化营销服务",
  youmaiContent: "优麦传媒成立于2016年7月，隶属于多麦股份。是一家以新媒体运营、社会化营销服务为主营业务的互联网企业。服务内容包括：新媒体账号布局、搭建优化、文章撰写、粉丝维护等新媒体一站式服务。",

  technicalServices: "技术服务",
  technicalServicesTitle: "技术赋能、技术驱动",
  technicalServicesContent: "致力做最好的社会化营销工具",
  maitian: "麦田",
  maitianTitle: "致力做最好的社会化营销工具",
  maitianContent: "为流量主及广告主技术营销赋能，主要为社群流量提供营销裂变产品、流量变现产品、为品牌主传播品牌提供营销传播产品",

  electronic: "电商运营",
  xiaomai: "小麦电商",
  xiaomaiTitle: "为品牌提供全域电商代运营服务",
  xiaomaiContent: "小麦电商是多麦旗下店铺代运营部门，成立于2020年，面对市场上众多以传统店铺运营能力为核心的众多代运营公司，选择以新媒体电商代运营切入市场，基于天猫、京东等传统电商平台的代运营能力基础上，重点布局抖音小店、快手小店等新内容电商平台，以品牌方的粉丝为核心，通过不同平台、不同营销矩阵的搭建，进行精细化运营，建立品牌与粉丝的差异化场景连接，打造以运营能力为核心，内容生产与资源整合为优势的一站式电商服务平台，为品牌主带来品效合一的电商代运营服务。",

  detail: '了解详情',

  // comBusinessMJTitle:'麦加全域营销',
  // comBusinessMJContent:'专注提供内容营销和效果营销',
  // comBusinessCPSTitle:'CPS广告联盟',
  // comBusinessCPSContent:'专注全球新零售效果营销服务',
  // comBusinessRJTitle:'茹佳文化',
  // comBusinessRJContent:'专注于泛时尚IP打造和商业化运作',
  // comBusinessMTTitle:'麦田创新',
  // comBusinessMTContent:'致力做最好的社会化营销工具',
  AITitle: "小麦AI实验室",
  AIContent: "我们拥有一支资深的AI 智能研发团队，深入研究自然语言处理和图像处理技术。",
  AITitle1: "W+ 微信爆文分析系统",
  AIContent1: "结合词典构建、中文分词、实体识别、自动摘要、关键词提取、文本分类及情感分析等自然语言处理技术孵化各类自然语言处理应用，如：信息检索、信息抽取、文本分析、文本匹配、违规检测、机器翻译、人机对话等。",
  AITitle2: "麦搜-图像搜索技术",
  AIContent2: "基于深度学习和图像处理技术的研发，包括图像特征提取、图像分类、主体检测、多目标检测、图像文字识别、手写体文字识别等技术；可应用于各种图片自动归类、目标检测、内容识别、图像检索类场景。",
  advantageTitlt: "核心优势",
  // advantageContent:'我是文案描述文案描述文案描述',
  advantageTitlt1: "技术优势",
  advantageContent1: "专注自然语言处理和图像处理研究，运用AI人工智能及大数据技术驱动业务增长。",
  advantageTitlt2: "内容创意",
  advantageContent2: "多元化广告形式+深度定制传播内容，为品牌客户提供 4A 级营销服务。",
  advantageTitlt3: "媒体资源",
  advantageContent3: "坐拥35w+媒体资源库和强大的全渠道媒体资源整合能力，深耕泛时尚领域。",
  advantageTitlt4: "团队服务",
  advantageContent4: "专注效果营销广告服务的国际化团队服务，丰富的多元化理论沉淀。",
  advantageTitlt5: "广告客户",
  advantageContent5: "为全球 800+ 泛时尚知名品牌提供品效销服务。",
  advantageTitlt6: "产品创新",
  advantageContent6: "自主研发社群营销工具，助力圈层KOL提升流量变现效率。",
  momentTitle: "多麦时刻",
  momentContent: "我们是一个年轻的正在高速成长的创业团队，“快乐工作、认真生活”是我们的态度。",

  numberICP: "浙ICP备14025287号",
  remark: " | © 2011-2019 多麦股份"
};

export {
  home
};